var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vaadin:megafone",
    clipPath: "url(#clip0_0_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3438 7.2L19.6875 6.66667V1.33333C19.6875 0.533333 19.1625 0 18.375 0C17.5875 0 17.0625 0.533333 17.0625 1.33333V2C14.4375 3.2 10.5 5.33333 6.5625 5.33333H3.28125C1.44375 5.33333 0 6.93333 0 8.66667C0 9.86667 0.65625 10.9333 1.575 11.4667L3.01875 19.3333C3.01875 19.7333 3.4125 20 3.9375 20H4.2L8.925 19.0667C9.45 18.9333 9.7125 18.5333 9.58125 18.1333C9.1875 17.3333 8.53125 16.1333 8.00625 15.7333C7.74375 15.6 7.35 14.5333 7.0875 13.3333H7.875V12.1333C11.4187 12.5333 15.75 14.2667 17.0625 15.3333V16C17.0625 16.8 17.5875 17.3333 18.375 17.3333C19.1625 17.3333 19.6875 16.8 19.6875 16V10.6667L20.2125 10.2667C20.7375 9.86667 21 9.33333 21 8.8V8.53333C21 8 20.7375 7.6 20.3438 7.2ZM2.625 6.66667H6.5625V8H2.625V6.66667ZM7.35 16.8C7.48125 16.8 7.74375 17.2 8.00625 17.7333L4.33125 18.6667L3.01875 12H5.5125C5.775 13.7333 6.3 16.2667 7.35 16.8ZM17.0625 13.7333C14.9625 12.6667 11.2875 11.0667 7.875 10.6667V6.66667C11.2875 6.26667 14.9625 4.8 17.0625 3.6V13.7333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.9301bcbd93f65e24731e8083b5b089c5.svg";
export { ForwardRef as ReactComponent };